import { createContext, FC, ReactNode, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { useUserStore } from '../../../entities/user/stores/user.store'
import { useGlobalError } from '../handlers/error-handler'
import { ErrorPage } from '../pages/error.page'
import { ServerError } from '../types/server-error'

type GlobalErrorContextType = {
  error: ServerError | Error | null
  setError: (error: ServerError | Error | null) => void
}

const GlobalErrorContext = createContext<GlobalErrorContextType | undefined>(undefined)

export const GlobalErrorProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { t } = useTranslation()
  const { error, setError } = useGlobalError()
  const logout = useUserStore((state) => state.logout)

  const err = error as any

  useEffect(() => {
    if (err?.status === 404) {
      toast.error(t('common.errors.notFound'))
      setError(null)
    }
  }, [err, setError, t])

  if (err && err?.status !== 404) {
    if (err?.status === 401) {
      logout()
      // eslint-disable-next-line no-undef
      window.location.href = '/'
    }

    console.log(err)

    return (
      <ErrorPage
        message={err.message}
        status={err?.status ?? 500}
      />
    )
  }

  return <GlobalErrorContext.Provider value={{ error, setError }}>{children}</GlobalErrorContext.Provider>
}
